
const Social = () => {
    return (
        <div className="home__social">
            <a href="https://www.instagram.com/rfkyyyyy/" className='home__social-icon' target="_blank">
                <i class="uil uil-instagram"></i>
            </a>
            <a href="https://github.com/rifkyaa" className='home__social-icon' target="_blank">
                <i class="uil uil-github-alt"></i>
            </a>
            <a href="https://web.facebook.com/rifkyandriansyah.anggela" className='home__social-icon' target="_blank">
                <i class="uil uil-facebook-f"></i>
            </a>
        </div>
    )
}

export default Social